import { Link, useLocation } from 'react-router-dom';
import { helpSectionForPath, helpTitleForSection } from './helpMap';

/**
 * Botão "?" do cabeçalho — abre a Ajuda já na seção da tela atual.
 *
 * O custo de pedir ajuda tem que ser menor que o de desistir. Mandar a
 * pessoa pro topo de uma central com 26 seções é o mesmo que não ajudar:
 * daqui ela cai direto no assunto que estava tentando resolver.
 *
 * Some nas telas sem seção correspondente (login, 404) — botão que leva
 * a lugar nenhum ensina a não clicar.
 */
export function HelpButton() {
  const { pathname } = useLocation();
  const sectionId = helpSectionForPath(pathname);
  if (!sectionId) return null;

  const title = helpTitleForSection(sectionId);
  const label = title ? `Ajuda sobre ${title}` : 'Ajuda';

  return (
    <Link
      to={`/ajuda#ajuda-${sectionId}`}
      title={label}
      aria-label={label}
      data-testid="help-contextual"
      data-help-section={sectionId}
      className="inline-flex items-center justify-center w-9 h-9 rounded-md text-ink-500 hover:text-brand-700 hover:bg-brand-50 transition-colors"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        className="w-5 h-5"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M9.6 9.2a2.5 2.5 0 1 1 3.3 2.4c-.6.2-.9.8-.9 1.4v.5" />
        <path d="M12 16.8h.01" />
      </svg>
    </Link>
  );
}
